import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import WrapperContainer from '../Container/WrapperContainer';
import GridItem from '../Grid/GridItem';
// import NavLink from '../Link/CustomNavLink';
import Typography from '../Typography/CustomTypography';
import { Role } from '../../common/Constants';

import styles from '../../assets/jss/components/userFooterStyle';
import _ from 'lodash';

const useStyles = makeStyles(styles);

const UserFooter = (props) => {
    const {
        isAuthorized,
        role,
        eventInfo,
        customColor,
        roleNoLogin,
    } = props;
    const classes = useStyles(props);
    return (
        <>
            {!_.isEmpty(eventInfo) && (
                <footer className={(roleNoLogin || role === Role.organizer) ? classes.footerOrganizer : classes.footer}>
                    <WrapperContainer style={{ alignItems: 'center' }}>
                        <GridItem xs={12} md={4}>
                            <Box display="flex" alignItems="center" flexDirection="row" flexWrap="wrap">
                                {/* {isAuthorized && Number(role) !== Role.admin && (
                                    <a
                                        target="blank"
                                        style={{ textDecoration: 'none' }}
                                        href={Number(role) === Role.organizer ? eventInfo.survey_link_organizer : eventInfo.survey_link_viewer}
                                        className={classes.noflex}
                                    >
                                        アンケート
                                    </a>
                                )} */}
                                {/* <NavLink text="よくある質問" link="/question" className={classes.noflex} /> */}
                                {/* <a target="blank" style={{ textDecoration: 'none' }} href={Number(role) === Role.organizer ? `/${eventInfo.short_name}/faq` : `/${eventInfo.short_name}/QA`} className={classes.noflex}>よくある質問</a> */}
                            </Box>
                        </GridItem>
                        <GridItem xs={12} md={4}>
                            <Box textAlign="center" paddingTop={1.25} paddingBottom={1.25}>
                                <Typography color="info" variant="h6" bold customColor={(roleNoLogin || role === Role.organizer) ? '' : customColor?.event_name_text_color}>
                                    JUMBO Co.,LTD.
                                </Typography>
                            </Box>
                        </GridItem>
                        <GridItem xs={12} md={4}>
                            <Box paddingTop={1.5} paddingBottom={1.5}>
                                <Typography variant="subtitle1" align="right" customColor={(roleNoLogin || role === Role.organizer) ? '' : customColor?.contents_text_color}>
                                    ©
                                    {' '}
                                    <b>JUMBO Co.,LTD.</b>
                                    {' '}
                                    All rights reserved.
                                </Typography>
                            </Box>
                        </GridItem>
                    </WrapperContainer>
                </footer>
            )}
        </>

    );
};

UserFooter.defaultProps = {
    role: 2,
    isAuthorized: false,
    eventInfo: {},
    customColor: {},
    roleNoLogin: 0,
};

UserFooter.propTypes = {
    role: PropTypes.number,
    isAuthorized: PropTypes.bool,
    eventInfo: PropTypes.oneOfType([() => null, PropTypes.object]),
    customColor: PropTypes.oneOfType([() => null, PropTypes.object]),
    roleNoLogin: PropTypes.oneOfType([() => null, PropTypes.object]),
};

const mapStateToProps = (state) => ({
    isAuthorized: state.auth.credential.isAuthorized,
    eventInfo: state.registration.registrationViewer.data,
    role: state.auth.credential.data.role,
    customColor: state.registration.registrationViewer.data?.settings_colors_viewer,
});

export default connect(mapStateToProps)(UserFooter);
